import React from 'react';
import {
    Show, TabbedShowLayout, Tab,
    TextField, DateField, ReferenceManyField, Datagrid, Pagination,
} from 'react-admin';
import { ColoredBooleanField } from '../../components/fields';
import Title from './Title';

import { withStyles } from '@material-ui/core/styles';
import styles from '../../styles/showStyles';

const ShowPagination = props => <Pagination rowsPerPageOptions={[10, 25, 50, 100, 250]} {...props} />;

const ZonesShow = withStyles(styles)(({ classes,...props }) => (
    <Show title={<Title />} {...props}>
        <TabbedShowLayout>
            <Tab
                label='resources.zones.tabs.details'
            >
                <TextField
                    source='ZoneNumber'
                />
                <ColoredBooleanField
                    source='Active'
                />
                <DateField
                    source='CreateDate'
                    showTime
                    className={classes.inlineBlock}
                />
                <DateField
                    source='ModifiedDate'
                    showTime
                    className={classes.inlineBlock}
                />
            </Tab>
            <Tab
                label='resources.zones.tabs.districts'
                path='districts'
            >
                <ReferenceManyField
                    reference='districts'
                    target='ZoneID'
                    sort={{ field: 'DistrictName', order: 'ASC' }}
                    perPage={25}
                    addLabel={false}
                    pagination={<ShowPagination />}
                >
                    <Datagrid
                        rowClick='show'
                    >
                        <TextField
                            source='DistrictName'
                        />
                        <TextField
                            source='MultiDistrictName'
                            headerClassName={classes.multiDistrictName}
                            cellClassName={classes.multiDistrictName}
                        />
                    </Datagrid>
                </ReferenceManyField>
            </Tab>
            <Tab
                label='resources.zones.tabs.clubs'
                path='clubs'
            >
                <ReferenceManyField
                    reference='clubs'
                    target='ZoneID'
                    sort={{ field: 'ClubName', order: 'ASC' }}
                    perPage={25}
                    addLabel={false}
                    pagination={<ShowPagination />}
                >
                    <Datagrid
                        rowClick='show'
                    >
                        <TextField
                            source='ClubName'
                        />
                        <TextField
                            source='DistrictName'
                            headerClassName={classes.districtName}
                            cellClassName={classes.districtName}
                        />
                        <TextField
                            source='StateCode'
                            headerClassName={classes.stateCode}
                            cellClassName={classes.stateCode}
                        />
                        <TextField
                            source='CountryCode'
                            headerClassName={classes.countryCode}
                            cellClassName={classes.countryCode}
                        />
                    </Datagrid>
                </ReferenceManyField>
            </Tab>
            <Tab
                label='resources.zones.tabs.members'
                path='members'
            >
                <ReferenceManyField
                    reference='members'
                    target='ZoneID'
                    sort={{ field: 'LastName', order: 'ASC' }}
                    perPage={25}
                    addLabel={false}
                    pagination={<ShowPagination />}
                >
                    <Datagrid
                        rowClick='show'
                    >
                        <TextField
                            source='LastName'
                            headerClassName={classes.lastName}
                            cellClassName={classes.lastName}
                        />
                        <TextField
                            source='FirstName'
                            headerClassName={classes.firstName}
                            cellClassName={classes.firstName}
                        />
                        <TextField
                            source='Email'
                            headerClassName={classes.email}
                            cellClassName={classes.email}
                        />
                        <TextField
                            source='ClubName'
                            headerClassName={classes.clubName}
                            cellClassName={classes.clubName}
                        />
                        <TextField
                            source='DistrictName'
                            headerClassName={classes.districtName}
                            cellClassName={classes.districtName}
                        />
                        <TextField
                            source='StateCode'
                            headerClassName={classes.stateCode}
                            cellClassName={classes.stateCode}
                        />
                        <TextField
                            source='CountryCode'
                            headerClassName={classes.countryCode}
                            cellClassName={classes.countryCode}
                        />
                    </Datagrid>
                </ReferenceManyField>
            </Tab>

        </TabbedShowLayout>
    </Show>
));
export default ZonesShow;